<template>
  <!--右键tab页组件-->
  <div>
    <ul class="contextmenu" v-show="show">
      <li v-if="info == null">
        <el-button type="text" @click.stop="operation('addFolder')">新增文件夹</el-button>
      </li>
      <li v-if="info != null">
        <el-button type="text" icon="el-icon-edit" @click.stop="operation('rename')">重命名</el-button>
      </li>

      <li v-if="info == null">
        <el-button type="text" @click.stop="operation('uploadFile')">上传</el-button>
      </li>
      <!-- <li>
        <el-button type="text"  @click="operation('multiSelect')">{{ isMultiSelectMode ? '取消多选' : '多选' }}</el-button>
      </li> -->
      <li v-if="selectedItems.length > 0">
        <el-button type="text" @click.stop="operation('batchDownload')">批量下载({{ selectedItems.length
          }})</el-button>
      </li>
      <li v-if="selectedItems.length > 0">
        <el-button type="text" @click.stop="operation('batchDelete')">批量删除({{ selectedItems.length
          }})</el-button>
      </li>
      <li v-if="selectedItems.length > 0">
        <el-button type="text" @click.stop="operation('batchMove')">批量移动({{ selectedItems.length
          }})</el-button>
      </li>
      <li v-if="info != null && info.type === 'file'">
        <el-button type="text" icon="el-icon-download" @click.stop="operation('downloadFile')">下载</el-button>
      </li>
      <!-- <li v-if="
        info != null &&
        info.type === 'file' &&
        $config.supportFile.view.indexOf(info.fileInfo.fileType) !== -1
      ">
        <el-button type="text"  @click.stop="operation('view')">在线预览</el-button>
      </li> -->
      <!-- <li v-if="
        info != null &&
        info.type === 'file' &&
        $config.supportFile.edit.indexOf(info.fileInfo.fileType) !== -1
      ">
        <el-button type="text"  @click.stop="operation('edit')">在线编辑</el-button>
      </li> -->
      <li v-if="info != null && info.type === 'file'">
        <el-button type="text" icon="el-icon-guide" @click.stop="operation('move')">移动</el-button>
      </li>
      <!-- <li v-if="info != null && info.type === 'file'">
        <el-button type="text" icon="el-icon-document-copy" @click.stop="operation('copy')">复制</el-button>
      </li> -->
      <li v-if="
        info != null &&
        info.type === 'file' &&
        $config.supportFile.decompression.indexOf(info.fileInfo.fileType) !==
        -1
      ">
        <el-button type="text" @click.stop="operation('decompression')">解压</el-button>
      </li>
      <!-- <li v-if="
        info != null &&
        info.type === 'file' &&
        $config.supportFile.toPdf.indexOf(info.fileInfo.fileType) !== -1
      ">
        <el-button type="text"  @click.stop="operation('toPDF')">转PDF</el-button>
      </li> -->
      <!-- <li v-if="info != null">
        <el-button type="text" icon="el-icon-setting" @click.stop="operation('setting')">设置</el-button>
      </li> -->
      <li v-if="info != null && info.type === 'file'">
        <el-button type="text" icon="el-icon-refresh" @click.stop="operation('update')">更新版本</el-button>
      </li> 
      <li v-if="info != null && info.fileInfo != null &&info.fileInfo.fileType =='docx'">
        <el-button type="text" icon="el-icon-c-scale-to-original" @click.stop="operation('compare')">文件对比</el-button>
      </li>
      <li
        v-if="info != null && info.fileInfo != null && info.fileInfo.status != null && [1, 2, -1, -2].includes(info.fileInfo.status)">
        <el-button type="text" icon="el-icon-sort" @click.stop="operation('progress')">审批进度</el-button>
      </li>
      <li
        v-if="info != null && info.fileInfo != null && info.fileInfo.status != null && [0].includes(info.fileInfo.status)">
        <el-button type="text" icon="el-icon-circle-check" @click.stop="operation('batchApproval')">批量提交审批</el-button>
      </li>
      <li
        v-if="info != null && info.fileInfo != null && info.fileInfo.status != null && [0].includes(info.fileInfo.status)">
        <el-button type="text" icon="el-icon-circle-check" @click.stop="operation('approval')">提交审批</el-button>
      </li>
      <li
        v-if="info != null && info.fileInfo != null && info.fileInfo.status != null && [0, -2].includes(info.fileInfo.status) && canDelete">
        <el-button type="text" icon="el-icon-delete" @click.stop="operation('delete')"
          style="color: red;">删除</el-button>
      </li>
      <li v-if="info != null && info.fileInfo != null && info.fileInfo.status === 2">
        <el-button type="text" icon="el-icon-s-release" @click.stop="operation('discard')"
          style="color: red;">废弃</el-button>
      </li>
    </ul>
    <!--上传按键-->
    <input multiple="true" :key="fileInputKey" type="file" ref="fileInput" @change="onFileChange"
      style="display: none" />
    <folderTree ref="folderTree" :title="folderTreeTitle"></folderTree>

    <!-- 更新版本弹窗 -->
    <el-dialog title="更新文件版本" :visible.sync="updateDialogVisible" width="500px" @click.native.stop>
      <!-- 当前文件信息 -->
      <div style="background: #f5f7fa; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
        <div style="margin-bottom: 8px;">
          <span style="color: #606266; font-weight: bold;">当前文件：</span>
          <span style="color: #303133;">{{ info ? info.name : '' }}</span>
        </div>
        <div>
          <span style="color: #606266; font-weight: bold;">当前版本：</span>
          <span style="color: #409eff;">{{ currentVersion }}</span>
        </div>
      </div>

      <el-radio-group v-model="updateType" style="margin-bottom: 20px;">
        <el-radio label="upload">上传文件更新</el-radio>
        <el-radio label="version">现有基础上更新</el-radio>
      </el-radio-group>

      <el-form :model="updateForm" label-width="100px">
        <el-form-item label="版本号" required>
          <el-input style="width: 120px;" v-model="updateForm.versionNumber1" @input="handleVersionInput"
            maxlength="10">
            <template slot="prepend">V</template>
          </el-input> .
          <el-input style="width: 70px;" v-model="updateForm.versionNumber2" @input="handleVersionInput" maxlength="10">
          </el-input>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">格式：V + 数字（如 V1.1）</div>
        </el-form-item>

        <el-form-item label="上传文件" v-if="updateType === 'upload'" required>
          <el-upload class="upload-demo" drag :action="uploadAction" :auto-upload="false" :file-list="uploadFileList"
            :on-change="handleUpdateFileChange" :on-remove="handleUpdateFileRemove">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 发起审核弹窗 -->
    <!-- <folderTreeTest ref="folderTreeTest"></folderTreeTest> -->
    <initiateApprovalModal ref="initiateApprovalModal" @ok="refresh"></initiateApprovalModal>
    <approvalInstanceDrawer ref="approvalInstanceDrawer"></approvalInstanceDrawer>
    <folderPermissionDialog ref="folderPermissionDialog"    >
    </folderPermissionDialog>
  </div>
</template>

<script> 
 import { MessageBox } from 'element-ui'; 

export default {
  name: "fileTab",
  props: {
    left: Number,
    top: Number,
    //当前选中的菜单
    menuId: String,
    pid: String,
    //多选模式
    isMultiSelectMode: {
      type: Boolean,
      default: false,
    },
    //已选中的项目
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    folderTree: () => import("@/components/folder/folderTree.vue"),
    // folderTreeTest: () => import("@/components/approval/folderTreeTest.vue"),
    initiateApprovalModal: () => import("@/components/approval/initiateApprovalModal.vue"),
    approvalInstanceDrawer: () => import("@/components/approval/approvalInstanceDrawer.vue"),

    folderPermissionDialog: () => import('@/components/folder/folderPermissionDialog.vue'),

  },
  data() {
    return {
      //显示标识
      show: false,
      //当前选中的数据
      info: null,
      //选中的文件
      selectedFile: null,
      //上传组件key
      fileInputKey: 0,
      //翻译
      typeMap: {
        file: "文件",
        folder: "文件夹",
      },
      //文件夹树
      folderTree: [{}],
      //文件树标题
      folderTreeTitle: "解压到",
      //更新弹窗显示
      updateDialogVisible: false,
      //更新类型：upload-上传文件，version-仅更新版本
      updateType: 'upload',
      //更新表单
      updateForm: {
        versionNumber: '', // 只存储数字部分
        versionNumber1: '',
        versionNumber2: '',
      },
      //更新文件列表
      updateFileList: [],
      //上传文件列表
      uploadFileList: [],
      //更新文件对象
      updateFile: null,
      //上传地址
      uploadAction: '',
      //当前版本
      currentVersion: 'V1.0',
    };
  },
  computed: {
    //是否有删除权限：拥有全局按钮权限 或 当前资源的 canOperateAll 数据权限
    canDelete() {
      if (this.has('addFileButton')) return true;
      return this.canOperateAllOf(this.info);
    },
  },
  mounted() {
    window.onclick = (res) => {
      this.offDia();
    };
  },

  methods: {
    /**
     * 提取目标资源的 canOperateAll 数据权限（兼容顶层与嵌套结构）
     * @param {Object} target - 文件/文件夹列表项
     * @returns {boolean}
     */
    canOperateAllOf(target) {
      if (!target) return false;
      const op =
        target.operationPermission ||
        (target.fileInfo && target.fileInfo.operationPermission) ||
        (target.fileFolder && target.fileFolder.operationPermission);
      return !!(op && op.canOperateAll);
    },
    //操作
    operation(code) { 
      switch (code) {
        case "setting":
          // 触发多选模式切换 
          if (this.info.type === 'file') {
            // 文件权限设置
            this.$refs.folderPermissionDialog.openEditDialog(this.info.id, 1);
          } else {
            // 文件夹权限设置
            this.$refs.folderPermissionDialog.openEditDialog(this.info.id, 0);
          }
          break;
        case "multiSelect":
          // 触发多选模式切换
          this.$emit("toggleMultiSelect");
          break;
        // case "batchDownload":
        //   // 批量下载
        //   MessageBox.confirm(
        //     `确认下载选中的 ${this.selectedItems.length} 个文件？`,
        //     "提示",
        //     {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       type: "info",
        //     },
        //   )
        //     .then(() => {
        //       this.selectedItems.forEach((item) => {
        //         if (item.type === "file") {
        //           setTimeout(() => {
        //             window.open(getDownloadFileUrl(item.id), "_blank");
        //           }, 100);
        //         }
        //       });
        //       this.$message.success("开始下载文件");
        //     })
        //     .catch(() => { });
        //   break;
        // case "batchDelete":
        //   // 批量删除
        //   MessageBox.confirm(
        //     `确认删除选中的 ${this.selectedItems.length} 个项目？`,
        //     "警告",
        //     {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       type: "warning",
        //     },
        //   )
        //     .then(() => {
        //       this.$parent.loading = true;
        //       const deletePromises = this.selectedItems.map((item) => {
        //         if (item.type === "file") {
        //           return this.$HttpService.del(`/file-info/delFile/${item.id}`);
        //         } else if (item.type === "folder") {
        //           return this.$HttpService.del(
        //             `/file-folder/delFolder/${item.id}`,
        //           );
        //         }
        //       });

        //       Promise.all(deletePromises)
        //         .then(() => {
        //           this.$message.success("批量删除成功");
        //           this.$emit("batchOperationComplete");
        //           this.$parent.loading = false;
        //         })
        //         .catch(() => {
        //           this.$parent.loading = false;
        //         });
        //     })
        //     .catch(() => { });
        //   break;
        // case "batchMove":
        //   // 批量移动
        //   this.$HttpService
        //     .get("/file-folder/findFolderTreeByLogin")
        //     .then((tree) => {
        //       this.folderTreeTitle = "批量移动到";
        //       this.folderTree[0].children = tree;
        //       this.$refs.folderTree.openDia(
        //         this.folderTree,
        //         this.batchMoveConfirm,
        //       );
        //     });
        //   break;
        case "addFolder":
          this.$prompt("请输入文件夹名称", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputValidator: (val) => {
              if (val.length > 30) {
                return "文件名长度不能大于30";
              }
              return true;
            },
          }).then(({ value }) => {
            this.$HttpService
              .post("/file-folder/add", {
                parentId: this.pid,
                folderName: value,
              })
              .then((res) => {
                this.$emit("ok");
              });
          });
          break;
        case "update":
          // 打开更新版本弹窗
          this.updateDialogVisible = true;
          this.updateType = 'upload';
          this.updateForm.versionNumber = '';
          this.updateForm.versionNumber1 = '';
          this.updateForm.versionNumber2 = '';
          this.updateFileList = [];
          this.uploadFileList = [];
          this.updateFile = null;
          // 获取当前文件版本
          if (this.info && this.info.fileInfo) {
            this.currentVersion = this.info.fileInfo.version || 'V1.0';
          } else {
            this.currentVersion = 'V1.0';
          }
          break;
        case "rename":
          this.$prompt("请输入名称", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputValue: this.info.name,
            inputValidator: (val) => {
              if (val.length > 40) {
                return "名称长度不能大于40";
              }
              return true;
            },
          }).then(({ value }) => {
            //判断类型
            if (this.info.type === "file") {
              //针对文件重命名
              this.$HttpService
                .put("/file-info/update", {
                  fileId: this.info.id,
                  fileName: value,
                })
                .then((res) => {
                  this.$emit("ok");
                });
            }
            if (this.info.type === "folder") {
              //针对文件夹重命名
              this.$HttpService
                .put("/file-folder/update", {
                  folderId: this.info.id,
                  folderName: value,
                })
                .then((res) => {
                  this.$emit("ok");
                });
            }
          });
          break;
        case "uploadFile":
          this.$refs.fileInput.click();
          break;
        case "downloadFile":
          // window.location.href = getDownloadFileUrl(this.info.id)
          this.downloadFile(this.info);

          break;
        case "view":
          //浏览器预览类型
          if (
            this.$config.supportFile.windowView.indexOf(
              this.info.fileInfo.fileType,
            ) !== -1
          ) {
            window.open(this.$util.getOpenFileUrl(this.info.id));
          } else {
            window.open(
              this.$util.getUrlAll(`/file-info/viewFile/${this.info.id}`),
            );
          }
          break;
        case "edit":
          window.open(
            this.$util.getUrlAll(`/file-info/editFile/${this.info.id}`),
          );
          break;

        case "delete":
          MessageBox.confirm(
            `是否确认删除${this.typeMap[this.info.type]}:${this.info.name}`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            },
          )
            .then(() => {
              //判断类型
              if (this.info.type === "file") {
                this.$HttpService
                  .del(`/file-info/delFile/${this.info.id}`)
                  .then(() => {
                    this.$emit("ok");
                  });
              }
              if (this.info.type === "folder") {
                this.$HttpService
                  .del(`/file-folder/delFolder/${this.info.id}`)
                  .then(() => {
                    this.$emit("ok");
                  });
              }
            })
            .catch(() => { });
          break;
        case "discard":
          MessageBox.confirm(
            `是否确认废弃${this.typeMap[this.info.type]}:${this.info.name}`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            },
          )
            .then(() => {
              //判断类型
              if (this.info.type === "file") {
                this.$HttpService
                  .post('/file-info/invalidateFile', { id: this.info.id })
                  .then(() => {
                    this.$emit("ok");
                  });
              }
            })
            .catch(() => { });
          break;
        case "decompression":
          this.$HttpService
            .get("/file-folder/findFolderTreeByLogin")
            .then((tree) => {
              this.folderTreeTitle = "解压到";
              this.folderTree[0].children = tree;
              this.$refs.folderTree.openDia(
                this.folderTree,
                this.decompressionConfim,
              );
            });
          break;
        case "toPDF":
          this.$parent.loading = true;
          this.$HttpService
            .get(`/file-info/fileToPdf/${this.info.id}`)
            .then(() => {
              this.$emit("ok");
              this.$parent.loading = false;
            })
            .catch(() => {
              this.$parent.loading = false;
            });
          break;
        case "copy":
          this.$HttpService
            .get("/file-folder/findFolderTreeByLogin")
            .then((tree) => {
              this.folderTreeTitle = "复制到";
              this.folderTree[0].children = tree;
              this.$refs.folderTree.openDia(this.folderTree, this.copyConfim);
            });
          break;
        case "move":
          this.$HttpService
            .get("/file-folder/findFolderTreeByLogin")
            .then((tree) => {
              this.folderTreeTitle = "移动到";
              this.folderTree[0].children = tree;
              this.$refs.folderTree.openDia(this.folderTree, this.moveConfim);
            });
          break;
        case "compare":
          // 触发文件对比模式
          this.$emit("enterCompareMode");
          break;
        case "batchApproval":
          // 触发批量提交审批模式
          this.$emit("enterBatchApprovalMode");
          break;
        case "approval":
          this.$refs.initiateApprovalModal.open([this.info.id]);
          break;
        case "progress":
          this.$refs.approvalInstanceDrawer.show(this.info.fileInfo);

          break;
      }
      this.show = false;
    },
    /**
     * 下载文件
     */
    async downloadFile(item) {
      if (!item || !item.fileInfo) {
        return;
      }
      try {
        const downloadUrl = this.$util.getDownloadFileUrl(item.id);
        // 使用 fetch 下载文件，避免中文文件名乱码
        const response = await fetch(downloadUrl);
        if (!response.ok) {
          this.$message.error("文件下载失败");
          return;
        }

        // 获取文件内容
        const blob = await response.blob();

        // 使用原始文件名（支持中文）
        const fileName = item.fileInfo.fileName || "download";

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("下载文件失败:", error);
        this.$message.error("文件下载失败");
      }
    },

    //文件变化监听
    onFileChange(event) {
      this.$parent.loading = true;
      this.selectedFile = event.target.files[0];
      //开始上传
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("folderId", this.pid);
      this.$HttpService
        .uploadFile(formData)
        .then(() => {
          this.fileInputKey++;
          this.$message.success("新增文件成功");

          //刷新表格
          this.$emit("ok");
          this.$parent.loading = false;
        })
        .catch(() => {
          this.fileInputKey++;
          this.$parent.loading = false;
        });
    },

    /**
     * 打开当前弹框
     * @param info
     */
    openDia(info) {
      this.show = true;
      this.info = info;

      // 在下一帧计算并调整菜单位置
      this.$nextTick(() => {
        const menu = this.$el.querySelector('.contextmenu');
        if (!menu) return;

        const event = window.event;
        if (!event) return;

        const menuWidth = menu.offsetWidth;
        const menuHeight = menu.offsetHeight;
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        let left = event.clientX;
        let top = event.clientY;

        // 右边界检测
        if (left + menuWidth > windowWidth) {
          left = windowWidth - menuWidth - 10;
        }

        // 下边界检测
        if (top + menuHeight > windowHeight) {
          top = windowHeight - menuHeight - 10;
        }

        // 左边界检测
        if (left < 0) {
          left = 10;
        }

        // 上边界检测
        if (top < 0) {
          top = 10;
        }

        menu.style.left = left + 'px';
        menu.style.top = top + 'px';
      });
    },
    /**
     * 关闭弹框
     * @param info
     */
    offDia() {
      this.show = false;
    },

    /**
     * 复制到确认事件回调
     * @param node
     */
    copyConfim(node) {
      this.$HttpService
        .post("/file-info/copyFile", {
          fileId: this.info.id,
          folderId: node.folderId,
        })
        .then(() => {
          //知道路径节点集合
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("copyOk", {
            node: node,
            path: nodes,
          });
          this.offDia();
        });
    },

    /**
     * 解压到确认事件回调
     * @param node
     */
    decompressionConfim(node) {
      this.$HttpService
        .post("/file-info/decompression", {
          fileId: this.info.id,
          folderId: node.folderId,
        })
        .then(() => {
          //知道路径节点集合
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("decompressionOk", {
            node: node,
            path: nodes,
          });
          this.offDia();
        });
    },

    /**
     * 移动到确认事件回调
     * @param node
     */
    moveConfim(node) {
      this.$HttpService
        .post("/file-info/moveFile", {
          fileId: this.info.id,
          folderId: node.folderId || '',
        })
        .then(() => {
          //知道路径节点集合
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("moveOk", {
            node: node,
            path: nodes,
          });
          this.offDia();
        })
        .catch((error) => {
        });
    },
    refresh() {
      this.$emit("ok");

    },

    /**
     * 批量移动确认回调
     * @param node
     */
    batchMoveConfirm(node) {
      this.$parent.loading = true;
      const movePromises = this.selectedItems.map((item) => {
        if (item.type === "file") {
          return this.$HttpService.post("/file-info/moveFile", {
            fileId: item.id,
            folderId: node.folderId,
          });
        }
        // 可以扩展文件夹移动
        return Promise.resolve();
      });

      Promise.all(movePromises)
        .then(() => {
          this.$message.success("批量移动成功");
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("batchOperationComplete");
          this.$parent.loading = false;
        })
        .catch(() => {
          this.$parent.loading = false;
        });
    },

    /**
     * 更新文件变化监听
     */
    handleUpdateFileChange(file, fileList) {
      this.updateFile = file.raw;
      this.uploadFileList = fileList;
    },

    /**
     * 更新文件移除监听
     */
    handleUpdateFileRemove(file, fileList) {
      this.updateFile = null;
      this.uploadFileList = fileList;
    },

    /**
     * 版本号输入限制（只允许数字和小数点）
     */
    handleVersionInput(value) {
      // 只允许数字
      const filtered = value.replace(/[^\d.]/g, '');
      // 确保只有一个小数点
      const parts = filtered.split('.');
      if (parts.length > 2) {
        this.updateForm.versionNumber = parts[0] + '.' + parts.slice(1).join('');
      } else {
        this.updateForm.versionNumber = filtered;
      }
    },

    /**
     * 确认更新版本
     */
    confirmUpdate() {
      // 验证版本号
      if (!this.updateForm.versionNumber1 || this.updateForm.versionNumber1.trim() === '' || !this.updateForm.versionNumber2 || this.updateForm.versionNumber2.trim() === '') {
        this.$message.warning('请输入版本号');
        return;
      }

      // 验证版本号格式（数字和小数点）
      const versionPattern = /^\d+(\.\d+)*$/;
      if (!versionPattern.test(this.updateForm.versionNumber.trim())) {
        this.$message.warning('版本号格式不正确，请输入数字格式，如：1.2');
        return;
      }

      // 组合完整版本号 V + 数字
      const fullVersion = 'V' + this.updateForm.versionNumber1.trim() + '.' + this.updateForm.versionNumber2.trim();

      // 如果选择上传文件模式，验证文件
      if (this.updateType === 'upload') {
        if (!this.updateFile) {
          this.$message.warning('请选择要上传的文件');
          return;
        }

        // 上传文件并更新版本
        this.$parent.loading = true;
        const formData = new FormData();
        formData.append('file', this.updateFile);
        formData.append('fileId', this.info.id);
        formData.append('version', fullVersion);

        this.$HttpService
          .post('/file-info/updateFileVersion', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {
            this.$message.success('更新文件版本成功');
            this.updateDialogVisible = false;
            this.$emit('ok');
            this.$parent.loading = false;
          })
          .catch(() => {
            this.$parent.loading = false;
          });
      } else {
        // 仅更新版本号（使用 form-data 格式）
        this.$parent.loading = true;
        const formData = new FormData();
        formData.append('fileId', this.info.id);
        formData.append('version', fullVersion);

        this.$HttpService
          .post('/file-info/updateFileVersion', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {
            this.$message.success('更新版本号成功');
            this.updateDialogVisible = false;
            this.$emit('ok');
            this.$parent.loading = false;
          })
          .catch(() => {
            this.$parent.loading = false;
          });
      }
    },

  },
};
</script>

<style scoped>
.contextmenu {
  /* width: 100px; */
  margin: 0;
  border: 1px solid #ccc;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  /* padding: 5px 0; */
  border-radius: 4px;
  font-size: 20px;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);

  ul {
    list-style-type: none;
  }

  li {
    margin: 0;
    padding: 0px 22px;
  }

  li:hover {
    background: #f2f2f2;
    cursor: pointer;
  }

  li button {
    color: #2c3e50;
  }
}
</style>
